import React from 'react';
import './Header.scss';
import { isMobile, isIos } from '../../static/helper';
import Shares from '../Shares/Shares';
import Navigation from '../Navigation/Navigation';
import { GA_Event } from '../Analytics/Analytics';

function Header(props) {
  const negishut = () => {
    document.getElementById('INDmenu-btn').click();
  }

  const shareNavigator = () => {
    window.navigator.share({
      title: "מצעד העשור ynet",
      text: '2020 עוד רגע כאן – וזה הזמן להכתיר את השירים, הסרטים וסדרות הטלוויזיה שעשו לנו את העשור האחרון. יחד עם צוות השופטים של ynet ומוסף "7 לילות" של "ידיעות אחרונות" – גם אתם תקבעו את התוצאות. אז קדימה, הצביעו והשפיעו!',
      url: "https://z.ynet.co.il/mshort/content/DecadeParade"
    });
    GA_Event('Share_Events', 'Decade Parade', 'Social - Share Mobile', 'Top Bar');

  }

  return (
    <>
      <header className={`header ${props.class}`}>

        <div className="logos">
          <h2 className="title" onClick={() => props.setPageSection("home")}>מצעד העשור</h2>

          <a target="_blank" href="https://www.ynet.co.il?utm_source=www.decadeparade.ynet.co.il/&utm_medium=referral&utm_campaign=DecadeParade" className="logo"></a>
          <div className="seven-nights"></div>
        </div>
        {props.class !== "home" ?
          <Navigation
            isResultsDisplay={props.isResultsDisplay}
            currentCategoryIndex={props.currentCategoryIndex}
            isResultsDisplay={props.isResultsDisplay}
            categories={props.categories}
            currentCategory={props.currentCategory}
            selectedItems={props.selectedItems}
            setCategory={props.setCategory} 
            categoryIndex={props.categoryIndex} 
            />
          : ""}
        <div className="share-section">
          {isMobile() || isIos() ?
            <div className="share" onClick={shareNavigator}></div>
            : <Shares label="Top Bar"/>
          }
          <div className="accessibility" onClick={negishut}></div>
        </div>
      </header>
      {props.class !== "home" ?
        <div className="navigation-title">
          {
            props.categories[props.currentCategoryIndex] && !props.isResultsDisplay ?
              <h3>בחרו מהרשימה {props.categories[props.currentCategoryIndex].title === "סדרות" ? "שלוש" : "שלושה"} {props.categories[props.currentCategoryIndex].title} שהכי אהבתם בעשור האחרון</h3>
              :
              <h3>ניתן לעבור על כל הבחירות שלך לפני שמצביעים</h3>
          }
        </div>
        : ""}
    </>
  );
}

export default Header;
